
export const industries = [
  {
    name: 'Row Crop Farming',
    tagline: 'Corn, Soybeans & Wheat',
    icon: 'ri-plant-line',
    description:
      'Row crops are the backbone of American agriculture — and the most vulnerable to compaction damage, missed spray windows, and stand loss from ground equipment. Our aerial application eliminates wheel traffic entirely, protecting your stands and getting product on when fields are too wet for ground rigs.',
    image:
      'https://public.readdy.ai/ai/img_res/ba11a055c41d54b4f1963cf4a3ed0e77.jpg',
    stats: [
      { label: 'Avg. Yield Gain', value: '9.2 bu/ac' },
      { label: 'Crop Saved', value: '3-5%' },
      { label: 'Timing Saved', value: '3-7 days' },
    ],
    challenges: [
      'Compaction from ground sprayers',
      'Missed fungicide windows after rain',
      'Stand loss from wheel traffic',
      'Late-season canopy penetration',
    ],
    solutions: [
      'Zero-traffic aerial application',
      'Wet-field capability',
      'Precision GPS-guided coverage',
      'Rapid mobilization in 24-48 hrs',
    ],
  },
  {
    name: 'Grain Production',
    tagline: 'Timely Fungicide & Nutrient Delivery',
    icon: 'ri-seedling-line',
    description:
      'Grain operations depend on precise timing — a 5-day delay during critical growth stages can cost $60-90 per acre in yield loss. We deliver fungicides, foliar nutrients, and plant growth regulators exactly when your grain needs them, regardless of field conditions.',
    image:
      'https://readdy.ai/api/search-image?query=Golden%20wheat%20field%20at%20sunset%20with%20mature%20wheat%20heads%20swaying%20in%20gentle%20breeze%20warm%20amber%20light%20professional%20agricultural%20photography%20showing%20vast%20grain%20production%20landscape%20American%20heartland%20farming&width=800&height=600&seq=ind-grain-v2-1&orientation=landscape',
    stats: [
      { label: 'Window Accuracy', value: '100%' },
      { label: 'Yield Protection', value: '$60-90/ac' },
      { label: 'Coverage Rate', value: '200 ac/day' },
    ],
    challenges: [
      'Narrow fungicide application windows',
      'Wet fields after rain events',
      'Equipment availability delays',
      'Uneven ground coverage',
    ],
    solutions: [
      'All-weather aerial access',
      'Uniform canopy coverage',
      'Same-week scheduling',
      'Variable rate application',
    ],
  },
  {
    name: 'Vineyards & Orchards',
    tagline: 'Precision Canopy Management',
    icon: 'ri-goblet-line',
    description:
      'High-value specialty crops demand surgical precision. Our low-altitude application delivers uniform coverage through dense canopies without the soil compaction that damages root systems in permanent plantings. Ideal for fungicide programs, foliar nutrition, and growth regulators.',
    image:
      'https://readdy.ai/api/search-image?query=Beautiful%20vineyard%20rows%20with%20lush%20green%20grapevines%20on%20rolling%20hills%20at%20golden%20hour%20warm%20sunlight%20filtering%20through%20grape%20leaves%20professional%20agricultural%20photography%20showing%20premium%20wine%20country%20landscape%20Napa%20Valley%20style&width=800&height=600&seq=ind-vineyard-v2-1&orientation=landscape',
    stats: [
      { label: 'Canopy Coverage', value: '95%+' },
      { label: 'Root Protection', value: '100%' },
      { label: 'Drift Reduction', value: '80%' },
    ],
    challenges: [
      'Dense canopy penetration',
      'Soil compaction in permanent rows',
      'Drift near sensitive areas',
      'Steep terrain access',
    ],
    solutions: [
      'Low-altitude precision spraying',
      'Zero ground compaction',
      'GPS-guided drift control',
      'Terrain-following flight paths',
    ],
  },
  {
    name: 'Timber & Woodland',
    tagline: 'Forestry & Invasive Species Control',
    icon: 'ri-tree-line',
    description:
      'Managed woodlands require a different approach. We provide aerial surveys for timber inventory, targeted invasive species treatment, and deer pressure assessment. Turn adjacent parcels into productive assets with comprehensive woodland management.',
    image:
      'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20mixed%20deciduous%20forest%20and%20managed%20timber%20woodland%20with%20autumn%20colors%20golden%20orange%20red%20leaves%20interspersed%20with%20green%20conifers%20professional%20forestry%20photography%20showing%20well%20managed%20woodland%20landscape&width=800&height=600&seq=ind-timber-v2-1&orientation=landscape',
    stats: [
      { label: 'Survey Speed', value: '500 ac/day' },
      { label: 'Invasive Control', value: '85%' },
      { label: 'Deer Reduction', value: '50-70%' },
    ],
    challenges: [
      'Inaccessible terrain for ground crews',
      'Invasive species spreading unchecked',
      'Deer browse pressure on edges',
      'Costly manual timber surveys',
    ],
    solutions: [
      'Aerial thermal deer surveys',
      'Targeted invasive treatment',
      'High-res timber inventory mapping',
      'Integrated wildlife management',
    ],
  },
  {
    name: 'Livestock & Pasture',
    tagline: 'Grazing Land Stewardship',
    icon: 'ri-home-4-line',
    description:
      'Healthy pastures mean healthy livestock. We help manage grazing land through aerial weed control, overseeding, and pasture health assessment — all without the soil disturbance that degrades grazing quality and promotes erosion.',
    image:
      'https://readdy.ai/api/search-image?query=Lush%20green%20rolling%20pasture%20land%20with%20cattle%20grazing%20in%20distance%20white%20fence%20lines%20morning%20mist%20rising%20from%20grass%20warm%20golden%20sunlight%20professional%20agricultural%20photography%20showing%20healthy%20livestock%20operation%20American%20countryside&width=800&height=600&seq=ind-livestock-v2-1&orientation=landscape',
    stats: [
      { label: 'Weed Reduction', value: '70%+' },
      { label: 'S oil Disturbance', value: 'Zero' },
      { label: 'Overseeding Rate', value: '150 ac/day' },
    ],
    challenges: [
      'Weed encroachment in pastures',
      'Soil erosion from equipment',
      'Uneven overseeding coverage',
      'Difficult terrain access',
    ],
    solutions: [
      'Aerial weed management',
      'No-disturbance overseeding',
      'Pasture health mapping',
      'Erosion-free application',
    ],
  },
  {
    name: 'Conservation & CRP',
    tagline: 'Sustainable Land Practices',
    icon: 'ri-earth-line',
    description:
      'Conservation reserve programs and cover crop management require careful, low-impact application methods. Our aerial approach plants cover crops, manages invasive species, and maintains conservation land without the soil disturbance that undermines the very goals of the program.',
    image:
      'https://readdy.ai/api/search-image?query=Beautiful%20conservation%20grassland%20prairie%20with%20native%20wildflowers%20and%20tall%20grasses%20swaying%20in%20wind%20butterflies%20and%20birds%20visible%20warm%20golden%20hour%20light%20professional%20nature%20photography%20showing%20healthy%20restored%20ecosystem%20American%20conservation%20land&width=800&height=600&seq=ind-conservation-v2-1&orientation=landscape',
    stats: [
      { label: 'Cover Crop Success', value: '92%' },
      { label: 'Compliance Rate', value: '100%' },
      { label: 'Cost Savings', value: '35%' },
    ],
    challenges: [
      'CRP compliance requirements',
      'Low-impact seeding needs',
      'Invasive species in sensitive areas',
      'Large acreage coverage',
    ],
    solutions: [
      'Compliant aerial seeding',
      'Zero-disturbance application',
      'Targeted invasive treatment',
      'Efficient large-scale coverage',
    ],
  },
];
